
















































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Auth, Logger } from 'aws-amplify';
import { Urls } from "@/Urls";
import Users from "@/store/modules/Users";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Decisions from "@/store/modules/Decisions";
import StorageImage from "@/components/common/StorageImage.vue";
import vuetify from '@/plugins/vuetify';

const usersModule = getModule(Users);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const decisionsModule = getModule(Decisions);
// Logger.LOG_LEVEL = "DEBUG";
const logger = new Logger("AccountMenu.vue");

@Component({
    components: { StorageImage },
})

export default class AccountMenu extends Vue {

    @Prop({type: Boolean})
    signedIn!: boolean;

    @Prop({ default: false, type: Boolean })
    embedApp!: boolean;

    @Prop()
    activeDecisions!: any;

    @Prop()
    currentDecision!: any;

    private showHelpSwitch: boolean = false;
    private readonly Urls: any = Urls;
    private user: any = {};
    private keyIncrement: number = 0;

    mounted() {
        this.user = Object.assign(this.user, this.userProfile);
    }

    get authUser() {
        return usersModule.currentAuthUser
    }

    get userProfile() {
        return usersModule.currentUserProfile || {};
    }

    get decisions() {
        if (this.activeDecisions) {
            return this.activeDecisions.filter((item) => {
                return item.apps.length > 0;
            });
        }
        else {
            return false;
        }
    }

    get showHome() {
        if (this.embedApp) {
            if ( decisionsModule.selectedDecisionUsers[this.userProfile.userId] ) {
                return  decisionsModule.selectedDecisionUsers[this.userProfile.userId].permissionAccess != 'USER';
            }
        }
        return true;
    }

    @Watch('signedIn')
    onSignedInChanged(newVal: boolean, oldVal: boolean) {
        if (newVal) {
            this.user = Object.assign(this.user, this.userProfile);
        }
    }

    @Watch('userProfile', {immediate: true, deep: true})
    userProfileChanged() {
        this.user = Object.assign(this.user, this.userProfile);
        this.keyIncrement++;
    }

    private signOut() {
        vuetify.framework.theme.themes.light = {...vuetify.userPreset.theme.themes.light};
        this.user = {};
        Auth.signOut();
    }

    // Help & Support - START
    get showHelpHotSpots() {
        return workspaceOptionsModule.showHelpHotSpots;
    }

    set showHelpHotSpots(visible: boolean) {
        workspaceOptionsModule.updateShowHelpHotSpots(visible);
    }
    // Help & Support - END
}

